import { CheckIcon } from '@heroicons/react/24/outline';

interface SupportExpectationsBoxProps {
  items: string[];
}

const SupportExpectationsBox = ({ items }: SupportExpectationsBoxProps) => {
  return (
    <div className="bg-muted/40 border rounded-md p-6 md:p-8 my-8">
      <h2 className="text-xl font-bold text-foreground mb-4">What to Expect</h2>
      <ul className="space-y-3">
        {items.map((item, index) => (
          <li key={index} className="flex items-start gap-3">
            <CheckIcon className="h-5 w-5 text-primary shrink-0 mt-0.5" />
            <span className="text-base text-foreground">{item}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default SupportExpectationsBox;
